
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import AuthService from '@/services/auth.service';

import vSelect from 'vue-select';
import debounce from 'lodash/debounce';
import { Validations } from 'vuelidate-property-decorators';
import { required, minValue, maxLength } from 'vuelidate/lib/validators';
import {
  Client,
  IJobModel,
  IJobNoteModel,
  JobNoteModel,
  UserModel,
  UserProfileModel
} from '@/services/api.service';


import toDateFormatter from '@/filters/todate.formatter';
import * as StringUtils from '@/utilities/string.utils';
import { EventBus } from '@/event-bus';
import { JobNoteCreatedMessage } from '@/services/eventbus.models';

const auth = new AuthService();

@Component({
  components: {
    vSelect
  },
  filters: {
    toDate: toDateFormatter
  },
  props: {
    jobGid: String,
    jobNumber: String,
  }
})
export default class AddJobNote extends Vue {
  private currentUser: UserProfileModel | null = null;
  private notes: string = '';

  public formIsValid: boolean | null = null;

  @Validations()
  private validations = {
    notes: { required }
  };

  private mounted() {
    const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
    clientService.getUserProfile().then((data: UserProfileModel) => {
      this.currentUser = data;
    });
  }
  private createJobNote() {
    // Do the work here
    // Run the validation
    // @ts-ignore
    this.$v.$touch();
    const me = this;
    // @ts-ignore
    if (me.$v.$invalid) {
      this.formIsValid = false;
      console.log('Submit failed. Form is invalid.');
    } else {
      // do your submit logic here
      me.formIsValid = true;
      console.log('Submit started. Form valid.');
      const newNote: JobNoteModel = new JobNoteModel();
      const user: UserModel = new UserModel();
      user.init(me.currentUser);

      newNote.init({
        createdByUserGid: user.gid,
        createdDateTime: new Date(),
        notes: me.notes,
        jobGid: me.$props.jobGid
      });
      console.log(newNote);
      const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
      // @ts-ignore
      me.$Progress.start();
      clientService
        .createJobNote(me.$props.jobGid, newNote)
        .then((data: JobNoteModel) => {
          // Route to the edit job list screen?
          console.log('Returned note:');
          console.log(data);
          // @ts-ignore
          me.$Progress.finish();
          // @ts-ignore
          me.$awn.success('Job note for ' + me.$props.jobNumber + ' created successfully');
          me.$emit('job-note-created', data);
          EventBus.$emit('job-note-created', new JobNoteCreatedMessage(me.$props.jobGid, data));
          me.closeModal();
        });
    }
  }
  private cancelEdit() {
    console.log('Cancelling edit...');
    // this.$emit('close');
    this.closeModal();
  }

  private closeModal() {
    this.$modal.hide('modal-jobnote-create');
  }
}
